import { useTranslations } from 'next-intl';

import ArrowBigIcon from '@/fo/icons/base/icons/big-arrow.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { styles } from './JoinSection.styles';

interface JoinSectionProps {
  onClickLoyalty: () => void;
}

export function JoinSection({ onClickLoyalty }: JoinSectionProps) {
  const slots = styles();

  const t = useTranslations('article.page.loyalty');

  return (
    <div className={slots.base()}>
      <div className={slots.container()}>
        <div className={slots.title()}>
          {t.rich('join.title', {
            highlight: (chunks) => (
              <span className={slots.highlight()}>{chunks}</span>
            ),
            nowrap: (chunks) => <span className={slots.nowrap()}>{chunks}</span>
          })}
        </div>
        <div className={slots.content()}>
          <div className={slots.description()}>{t('join.description')}</div>
          <UiKitButtonBase
            color="ghost"
            className={slots.button()}
            childrenClassName={slots.buttonChildren()}
            onClick={onClickLoyalty}
          >
            {t('button')}
            <ArrowBigIcon />
          </UiKitButtonBase>
        </div>
      </div>
    </div>
  );
}
